import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActionArea, CardContent, Typography, CardActions, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  title: {
    fontSize: 14,
  },
});

const IssueCard = (props) => {
  const classes = useStyles();

  const issue = props.issue;
  const customization = props.customization;
  //const index = props.index;
  return (
    <Card className={classes.root}>
      <CardActionArea 
        onClick={() => {
          props.users.isAuthenticated
          ? props.history.push(`/issue-tracker/issues/view/${issue.id}`)
          : props.setAlertOpen(true);
        }}
      >
        <CardContent>
          {
            customization.lastUpdated && 
            <Typography id="lastUpdated" className={classes.title} color="textSecondary" gutterBottom>
              Last updated at- {issue.lastUpdated}
            </Typography>
          }
          {
            customization.lastUpdatedBy &&
            <Typography id="lastUpdatedBy" className={classes.title} color="textSecondary" gutterBottom>
              Last updated by- {issue.lastUpdatedByName}
            </Typography>
          }
          {
            customization.description &&
            <Typography id="description" gutterBottom variant="h5" component="h2">
              {issue.description}
            </Typography>
          }
          {
            customization.severity &&
            <Typography id="severity" variant="body2" color="textSecondary" component="p">
              Severity- {issue.severity}
            </Typography>
          }
          {
            customization.status &&
            <Typography id="status" variant="body2" color="textSecondary" component="p">
              Status- {issue.status}
            </Typography>
          }
          <Typography style={{marginTop: "10px"}} variant="body2" component="p">
            {customization.createdDate ? issue.createdDate : null}
            {customization.createdDate && customization.resolvedDate ? " - " : null}
            {customization.resolvedDate ? (issue.resolvedDate ? issue.resolvedDate : "Not resolved") : null}
          </Typography>
          <Typography style={{marginTop: "10px"}} variant="body2" component="h2">
            {customization.loggedBy ? `Logged By- ${issue.loggedByName}`: null}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          id="editButton"
          onClick={() => {
            props.users.isAuthenticated 
            ? props.history.push(`/issue-tracker/issues/edit/${issue.id}`)
            : props.setAlertOpen(true);
          }}
          size="small"
          color="primary" 
          startIcon={<EditIcon />}
        >
          Edit
        </Button>
        <Button
          onClick={() => {
            props.users.isAuthenticated
            ? window.confirm("Are you sure you want to delete this issue?")
            ? props.actions.deleteIssue(issue) : console.log()
            : props.setAlertOpen(true);
          }}
          size="small" 
          color="secondary"
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      </CardActions>
    </Card>
  );
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssueCard));
